import React from 'react';
import HeadNext from 'next/head';

import { type ExposePath } from '@/types/expose';
import { useSettings } from '@/hooks/useSettings';

export enum IndexFollowEnum {
  INDEXFOLLOW = 'index,follow',
  NOINDEXNOFOLLOW = 'noindex,nofollow',
}

export type HeadProps = {
  title: string;
  description?: string;
  isIndexed: boolean;
  imageUrl?: string;
  paths?: ExposePath[];
  canonicalPath?: string;
};

export const Head = ({ title, description, isIndexed, imageUrl, paths, canonicalPath }: HeadProps) => {
  const { language } = useSettings();

  return (
    <HeadNext>
      <title>{title}</title>
      {Boolean(description) && <meta name="description" content={description} />}
      <meta property="og:title" content={title} />
      <meta property="og:locale" content={language} />
      <meta property="og:site_name" content="Engel &amp; Völkers" />
      {Boolean(description) && <meta property="og:description" content={description} />}
      {Boolean(imageUrl) && <meta property="og:image" content={imageUrl} />}
      <meta name="robots" content={isIndexed ? IndexFollowEnum.INDEXFOLLOW : IndexFollowEnum.NOINDEXNOFOLLOW} />
      {Boolean(canonicalPath) && <link rel="canonical" href={`https://www.engelvoelkers.com${canonicalPath}`} />}
      {paths?.map((path) => {
        return <link key={path.path} rel="alternate" hrefLang={path.language} href={`https://www.engelvoelkers.com${path.path}`} />;
      })}
    </HeadNext>
  );
};
